module.exports = __webpack_public_path__ + "img/start-active.ae8dac32.svg";